<div>
	<div class="modal-header">
		<h4 class="modal-title">Ajouter un nouveau dossier</h4>
		<button type="button" class="close" aria-label="Close" (click)="cancelDialog()"><span aria-hidden="true">&times;</span></button>
	</div>

	<div class="modal-body">
		<form [formGroup]="folderAddForm">
			<ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs">
				<li [ngbNavItem]="1">
					<a ngbNavLink>Général</a>
					<ng-template ngbNavContent>
						<div class="form-group">
							<label class="ls-label-strong" for="name">Nom du dossier</label>
							<input required #nameControl id="name" type="text" class="form-control" formControlName="nameControl" placeholder="Nom" ngbAutofocus>
						</div>

						<div class="form-group">
							<label class="ls-label-strong" for="folder_server">Dossier du serveur</label>
							<p-tree
								[value]="treeStructure"
								selectionMode="single"
								[(selection)]="selectedFolder"
								(onNodeSelect)="nodeSelect($event)"></p-tree>
						</div>

						<div class="form-group">
							<label class="ls-label-strong" for="engineer">Ingénieur associé</label>
							<select #engineerControl id="engineer" class="form-control" formControlName="engineerControl">
								<option *ngFor="let engineer of engineersList" [ngValue]="engineer._id">{{engineer.name}}</option>
							</select>

						</div>

						<div class="form-group">
							<label class="ls-label-strong" for="endDate">Date d'arrêt</label>
							<input #endDateControl id="endDate" type="date" class="form-control" formControlName="endDateControl">
						</div>
					</ng-template>
				</li>

				<li [ngbNavItem]="2">
					<a ngbNavLink>Droits sociétés</a>
					<ng-template ngbNavContent>
						<div class="form-group">
							<label class="ls-label-strong" for="companies">Droits des société</label>
							<p-listbox 
								id="companies"
								[options]="companiesList" 
								formControlName="companiesControl" 
								[metaKeySelection]="false" 
								[checkbox]="true" 
								[filter]="true" 
								[multiple]="true" 
								optionLabel="name"
								filterPlaceHolder="Nom de la société"
								[listStyle]="{'max-height': '10em'}">
							</p-listbox>
						</div>
					</ng-template>
				</li>

				<li [ngbNavItem]="3">
					<a ngbNavLink>Droits utilisateurs</a>
					<ng-template ngbNavContent>
						<div class="form-group">
							<label class="ls-label-strong">Droits propres des utilisateurs</label>
							<p-listbox 
								id="users"
								[options]="usersList" 
								formControlName="usersControl" 
								[metaKeySelection]="false" 
								[checkbox]="true" 
								[filter]="true" 
								[multiple]="true" 
								optionLabel="username"
								filterPlaceHolder="Identifiant de l'utilisateur"
								[listStyle]="{'max-height': '10em'}">
							</p-listbox>
						</div>
					</ng-template>
				</li>

				<li [ngbNavItem]="4">
					<a ngbNavLink>Email</a>
					<ng-template ngbNavContent>
						<div class="form-group">
							<label class="ls-label-strong" for="mail-subject">Sujet de l'email</label>
							<input required #emailSubjectControl id="mail-subject" type="text" class="form-control" formControlName="emailSubjectControl" placeholder="Sujet de l'email">
						</div>

						<div class="form-group">
							<label class="ls-label-strong" for="mail-intro">Introduction</label>
							<p-editor formControlName="emailIntroControl" [style]="{'height':'150px'}">
								<ng-template pTemplate="header">
									<span class="ql-formats">
										<button type="button" class="ql-bold" aria-label="Bold"></button>
										<button type="button" class="ql-italic" aria-label="Italic"></button>
										<button type="button" class="ql-underline" aria-label="Underline"></button>
									</span>
									<span class="ql-formats">
										<select class="ql-color">
											<option value="Black"></option>
											<option value="White"></option>
											<option value="AliceBlue"></option>
											<option value="AntiqueWhite"></option>
											<option value="Aqua"></option>
											<option value="Aquamarine"></option>
											<option value="Azure"></option>
											<option value="Beige"></option>
											<option value="Bisque"></option>
											<option value="BlanchedAlmond"></option>
											<option value="Blue"></option>
											<option value="BlueViolet"></option>
											<option value="Brown"></option>
											<option value="BurlyWood"></option>
											<option value="CadetBlue"></option>
											<option value="Chartreuse"></option>
											<option value="Chocolate"></option>
											<option value="Coral"></option>
											<option value="CornflowerBlue"></option>
											<option value="Cornsilk"></option>
											<option value="Crimson"></option>
											<option value="Cyan"></option>
											<option value="DarkBlue"></option>
											<option value="DarkCyan"></option>
											<option value="DarkGoldenRod"></option>
											<option value="DarkGray"></option>
											<option value="DarkGrey"></option>
											<option value="DarkGreen"></option>
											<option value="DarkKhaki"></option>
											<option value="DarkMagenta"></option>
											<option value="DarkOliveGreen"></option>
											<option value="DarkOrange"></option>
											<option value="DarkOrchid"></option>
											<option value="DarkRed"></option>
											<option value="DarkSalmon"></option>
											<option value="DarkSeaGreen"></option>
											<option value="DarkSlateBlue"></option>
											<option value="DarkSlateGray"></option>
											<option value="DarkSlateGrey"></option>
											<option value="DarkTurquoise"></option>
											<option value="DarkViolet"></option>
											<option value="DeepPink"></option>
											<option value="DeepSkyBlue"></option>
											<option value="DimGray"></option>
											<option value="DimGrey"></option>
											<option value="DodgerBlue"></option>
											<option value="FireBrick"></option>
											<option value="FloralWhite"></option>
											<option value="ForestGreen"></option>
											<option value="Fuchsia"></option>
											<option value="Gainsboro"></option>
											<option value="GhostWhite"></option>
											<option value="Gold"></option>
											<option value="GoldenRod"></option>
											<option value="Gray"></option>
											<option value="Grey"></option>
											<option value="Green"></option>
											<option value="GreenYellow"></option>
											<option value="HoneyDew"></option>
											<option value="LightGrey"></option>
											<option value="LightGreen"></option>
											<option value="LightPink"></option>
											<option value="LightSalmon"></option>
											<option value="LightSeaGreen"></option>
											<option value="LightSkyBlue"></option>
											<option value="LightSlateGray"></option>
											<option value="LightSlateGrey"></option>
											<option value="LightSteelBlue"></option>
											<option value="LightYellow"></option>
											<option value="Lime"></option>
											<option value="LimeGreen"></option>
											<option value="Linen"></option>
											<option value="Magenta"></option>
											<option value="Maroon"></option>
											<option value="MediumAquaMarine"></option>
											<option value="MediumBlue"></option>
											<option value="MediumOrchid"></option>
											<option value="MediumPurple"></option>
											<option value="MediumSeaGreen"></option>
											<option value="MediumSlateBlue"></option>
											<option value="MediumSpringGreen"></option>
											<option value="MediumTurquoise"></option>
											<option value="MediumVioletRed"></option>
											<option value="MidnightBlue"></option>
											<option value="MintCream"></option>
											<option value="MistyRose"></option>
											<option value="Moccasin"></option>
											<option value="NavajoWhite"></option>
											<option value="Navy"></option>
											<option value="OldLace"></option>
											<option value="Olive"></option>
											<option value="OliveDrab"></option>
											<option value="Orange"></option>
											<option value="OrangeRed"></option>
											<option value="Orchid"></option>
											<option value="PaleGoldenRod"></option>
											<option value="PaleGreen"></option>
											<option value="PaleTurquoise"></option>
											<option value="PaleVioletRed"></option>
											<option value="PapayaWhip"></option>
											<option value="Pink"></option>
											<option value="Plum"></option>
											<option value="PowderBlue"></option>
											<option value="Purple"></option>
											<option value="RebeccaPurple"></option>
											<option value="Red"></option>
											<option value="RosyBrown"></option>
											<option value="RoyalBlue"></option>
											<option value="SaddleBrown"></option>
											<option value="Salmon"></option>
											<option value="SandyBrown"></option>
											<option value="SeaGreen"></option>
											<option value="SeaShell"></option>
											<option value="Sienna"></option>
											<option value="Silver"></option>
											<option value="SkyBlue"></option>
											<option value="SlateBlue"></option>
											<option value="SlateGray"></option>
											<option value="SlateGrey"></option>
											<option value="Snow"></option>
											<option value="SpringGreen"></option>
											<option value="SteelBlue"></option>
											<option value="Tan"></option>
											<option value="Teal"></option>
											<option value="Thistle"></option>
											<option value="Tomato"></option>
											<option value="Turquoise"></option>
											<option value="Violet"></option>
											<option value="Wheat"></option>
											<option value="WhiteSmoke"></option>
											<option value="Yellow"></option>
											<option value="YellowGreen"></option>
										</select>
										<select class="ql-background">
											<option value="Black"></option>
											<option value="White"></option>
											<option value="AliceBlue"></option>
											<option value="AntiqueWhite"></option>
											<option value="Aqua"></option>
											<option value="Aquamarine"></option>
											<option value="Azure"></option>
											<option value="Beige"></option>
											<option value="Bisque"></option>
											<option value="BlanchedAlmond"></option>
											<option value="Blue"></option>
											<option value="BlueViolet"></option>
											<option value="Brown"></option>
											<option value="BurlyWood"></option>
											<option value="CadetBlue"></option>
											<option value="Chartreuse"></option>
											<option value="Chocolate"></option>
											<option value="Coral"></option>
											<option value="CornflowerBlue"></option>
											<option value="Cornsilk"></option>
											<option value="Crimson"></option>
											<option value="Cyan"></option>
											<option value="DarkBlue"></option>
											<option value="DarkCyan"></option>
											<option value="DarkGoldenRod"></option>
											<option value="DarkGray"></option>
											<option value="DarkGrey"></option>
											<option value="DarkGreen"></option>
											<option value="DarkKhaki"></option>
											<option value="DarkMagenta"></option>
											<option value="DarkOliveGreen"></option>
											<option value="DarkOrange"></option>
											<option value="DarkOrchid"></option>
											<option value="DarkRed"></option>
											<option value="DarkSalmon"></option>
											<option value="DarkSeaGreen"></option>
											<option value="DarkSlateBlue"></option>
											<option value="DarkSlateGray"></option>
											<option value="DarkSlateGrey"></option>
											<option value="DarkTurquoise"></option>
											<option value="DarkViolet"></option>
											<option value="DeepPink"></option>
											<option value="DeepSkyBlue"></option>
											<option value="DimGray"></option>
											<option value="DimGrey"></option>
											<option value="DodgerBlue"></option>
											<option value="FireBrick"></option>
											<option value="FloralWhite"></option>
											<option value="ForestGreen"></option>
											<option value="Fuchsia"></option>
											<option value="Gainsboro"></option>
											<option value="GhostWhite"></option>
											<option value="Gold"></option>
											<option value="GoldenRod"></option>
											<option value="Gray"></option>
											<option value="Grey"></option>
											<option value="Green"></option>
											<option value="GreenYellow"></option>
											<option value="HoneyDew"></option>
											<option value="LightGrey"></option>
											<option value="LightGreen"></option>
											<option value="LightPink"></option>
											<option value="LightSalmon"></option>
											<option value="LightSeaGreen"></option>
											<option value="LightSkyBlue"></option>
											<option value="LightSlateGray"></option>
											<option value="LightSlateGrey"></option>
											<option value="LightSteelBlue"></option>
											<option value="LightYellow"></option>
											<option value="Lime"></option>
											<option value="LimeGreen"></option>
											<option value="Linen"></option>
											<option value="Magenta"></option>
											<option value="Maroon"></option>
											<option value="MediumAquaMarine"></option>
											<option value="MediumBlue"></option>
											<option value="MediumOrchid"></option>
											<option value="MediumPurple"></option>
											<option value="MediumSeaGreen"></option>
											<option value="MediumSlateBlue"></option>
											<option value="MediumSpringGreen"></option>
											<option value="MediumTurquoise"></option>
											<option value="MediumVioletRed"></option>
											<option value="MidnightBlue"></option>
											<option value="MintCream"></option>
											<option value="MistyRose"></option>
											<option value="Moccasin"></option>
											<option value="NavajoWhite"></option>
											<option value="Navy"></option>
											<option value="OldLace"></option>
											<option value="Olive"></option>
											<option value="OliveDrab"></option>
											<option value="Orange"></option>
											<option value="OrangeRed"></option>
											<option value="Orchid"></option>
											<option value="PaleGoldenRod"></option>
											<option value="PaleGreen"></option>
											<option value="PaleTurquoise"></option>
											<option value="PaleVioletRed"></option>
											<option value="PapayaWhip"></option>
											<option value="Pink"></option>
											<option value="Plum"></option>
											<option value="PowderBlue"></option>
											<option value="Purple"></option>
											<option value="RebeccaPurple"></option>
											<option value="Red"></option>
											<option value="RosyBrown"></option>
											<option value="RoyalBlue"></option>
											<option value="SaddleBrown"></option>
											<option value="Salmon"></option>
											<option value="SandyBrown"></option>
											<option value="SeaGreen"></option>
											<option value="SeaShell"></option>
											<option value="Sienna"></option>
											<option value="Silver"></option>
											<option value="SkyBlue"></option>
											<option value="SlateBlue"></option>
											<option value="SlateGray"></option>
											<option value="SlateGrey"></option>
											<option value="Snow"></option>
											<option value="SpringGreen"></option>
											<option value="SteelBlue"></option>
											<option value="Tan"></option>
											<option value="Teal"></option>
											<option value="Thistle"></option>
											<option value="Tomato"></option>
											<option value="Turquoise"></option>
											<option value="Violet"></option>
											<option value="Wheat"></option>
											<option value="WhiteSmoke"></option>
											<option value="Yellow"></option>
											<option value="YellowGreen"></option>
										</select>
									</span>
									<span class="ql-formats">
										<button type="button" class="ql-strike" aria-label="Rayé"></button>
										<button type="button" class="ql-list" value="ordered" aria-label="list"></button>
										<button type="button" class="ql-list" value="bullet" aria-label="list"></button>
									</span>
									<span class="ql-formats">
										<button type="button" class="ql-link" aria-label="Lien"></button>
									</span>
								</ng-template>
							</p-editor>
						</div>

						<div class="form-group">
							<label class="ls-label-strong" for="mail-link">Lien</label>
							<p-editor formControlName="emailLinkControl" [style]="{'height':'150px'}">
								<ng-template pTemplate="header">
									<span class="ql-formats">
										<button type="button" class="ql-bold" aria-label="Gras"></button>
										<button type="button" class="ql-italic" aria-label="Italique"></button>
										<button type="button" class="ql-underline" aria-label="Souligné"></button>
									</span>
									<span class="ql-formats">
										<select class="ql-color">
											<option value="Black"></option>
											<option value="White"></option>
											<option value="AliceBlue"></option>
											<option value="AntiqueWhite"></option>
											<option value="Aqua"></option>
											<option value="Aquamarine"></option>
											<option value="Azure"></option>
											<option value="Beige"></option>
											<option value="Bisque"></option>
											<option value="BlanchedAlmond"></option>
											<option value="Blue"></option>
											<option value="BlueViolet"></option>
											<option value="Brown"></option>
											<option value="BurlyWood"></option>
											<option value="CadetBlue"></option>
											<option value="Chartreuse"></option>
											<option value="Chocolate"></option>
											<option value="Coral"></option>
											<option value="CornflowerBlue"></option>
											<option value="Cornsilk"></option>
											<option value="Crimson"></option>
											<option value="Cyan"></option>
											<option value="DarkBlue"></option>
											<option value="DarkCyan"></option>
											<option value="DarkGoldenRod"></option>
											<option value="DarkGray"></option>
											<option value="DarkGrey"></option>
											<option value="DarkGreen"></option>
											<option value="DarkKhaki"></option>
											<option value="DarkMagenta"></option>
											<option value="DarkOliveGreen"></option>
											<option value="DarkOrange"></option>
											<option value="DarkOrchid"></option>
											<option value="DarkRed"></option>
											<option value="DarkSalmon"></option>
											<option value="DarkSeaGreen"></option>
											<option value="DarkSlateBlue"></option>
											<option value="DarkSlateGray"></option>
											<option value="DarkSlateGrey"></option>
											<option value="DarkTurquoise"></option>
											<option value="DarkViolet"></option>
											<option value="DeepPink"></option>
											<option value="DeepSkyBlue"></option>
											<option value="DimGray"></option>
											<option value="DimGrey"></option>
											<option value="DodgerBlue"></option>
											<option value="FireBrick"></option>
											<option value="FloralWhite"></option>
											<option value="ForestGreen"></option>
											<option value="Fuchsia"></option>
											<option value="Gainsboro"></option>
											<option value="GhostWhite"></option>
											<option value="Gold"></option>
											<option value="GoldenRod"></option>
											<option value="Gray"></option>
											<option value="Grey"></option>
											<option value="Green"></option>
											<option value="GreenYellow"></option>
											<option value="HoneyDew"></option>
											<option value="LightGrey"></option>
											<option value="LightGreen"></option>
											<option value="LightPink"></option>
											<option value="LightSalmon"></option>
											<option value="LightSeaGreen"></option>
											<option value="LightSkyBlue"></option>
											<option value="LightSlateGray"></option>
											<option value="LightSlateGrey"></option>
											<option value="LightSteelBlue"></option>
											<option value="LightYellow"></option>
											<option value="Lime"></option>
											<option value="LimeGreen"></option>
											<option value="Linen"></option>
											<option value="Magenta"></option>
											<option value="Maroon"></option>
											<option value="MediumAquaMarine"></option>
											<option value="MediumBlue"></option>
											<option value="MediumOrchid"></option>
											<option value="MediumPurple"></option>
											<option value="MediumSeaGreen"></option>
											<option value="MediumSlateBlue"></option>
											<option value="MediumSpringGreen"></option>
											<option value="MediumTurquoise"></option>
											<option value="MediumVioletRed"></option>
											<option value="MidnightBlue"></option>
											<option value="MintCream"></option>
											<option value="MistyRose"></option>
											<option value="Moccasin"></option>
											<option value="NavajoWhite"></option>
											<option value="Navy"></option>
											<option value="OldLace"></option>
											<option value="Olive"></option>
											<option value="OliveDrab"></option>
											<option value="Orange"></option>
											<option value="OrangeRed"></option>
											<option value="Orchid"></option>
											<option value="PaleGoldenRod"></option>
											<option value="PaleGreen"></option>
											<option value="PaleTurquoise"></option>
											<option value="PaleVioletRed"></option>
											<option value="PapayaWhip"></option>
											<option value="Pink"></option>
											<option value="Plum"></option>
											<option value="PowderBlue"></option>
											<option value="Purple"></option>
											<option value="RebeccaPurple"></option>
											<option value="Red"></option>
											<option value="RosyBrown"></option>
											<option value="RoyalBlue"></option>
											<option value="SaddleBrown"></option>
											<option value="Salmon"></option>
											<option value="SandyBrown"></option>
											<option value="SeaGreen"></option>
											<option value="SeaShell"></option>
											<option value="Sienna"></option>
											<option value="Silver"></option>
											<option value="SkyBlue"></option>
											<option value="SlateBlue"></option>
											<option value="SlateGray"></option>
											<option value="SlateGrey"></option>
											<option value="Snow"></option>
											<option value="SpringGreen"></option>
											<option value="SteelBlue"></option>
											<option value="Tan"></option>
											<option value="Teal"></option>
											<option value="Thistle"></option>
											<option value="Tomato"></option>
											<option value="Turquoise"></option>
											<option value="Violet"></option>
											<option value="Wheat"></option>
											<option value="WhiteSmoke"></option>
											<option value="Yellow"></option>
											<option value="YellowGreen"></option>
										</select>
										<select class="ql-background">
											<option value="Black"></option>
											<option value="White"></option>
											<option value="AliceBlue"></option>
											<option value="AntiqueWhite"></option>
											<option value="Aqua"></option>
											<option value="Aquamarine"></option>
											<option value="Azure"></option>
											<option value="Beige"></option>
											<option value="Bisque"></option>
											<option value="BlanchedAlmond"></option>
											<option value="Blue"></option>
											<option value="BlueViolet"></option>
											<option value="Brown"></option>
											<option value="BurlyWood"></option>
											<option value="CadetBlue"></option>
											<option value="Chartreuse"></option>
											<option value="Chocolate"></option>
											<option value="Coral"></option>
											<option value="CornflowerBlue"></option>
											<option value="Cornsilk"></option>
											<option value="Crimson"></option>
											<option value="Cyan"></option>
											<option value="DarkBlue"></option>
											<option value="DarkCyan"></option>
											<option value="DarkGoldenRod"></option>
											<option value="DarkGray"></option>
											<option value="DarkGrey"></option>
											<option value="DarkGreen"></option>
											<option value="DarkKhaki"></option>
											<option value="DarkMagenta"></option>
											<option value="DarkOliveGreen"></option>
											<option value="DarkOrange"></option>
											<option value="DarkOrchid"></option>
											<option value="DarkRed"></option>
											<option value="DarkSalmon"></option>
											<option value="DarkSeaGreen"></option>
											<option value="DarkSlateBlue"></option>
											<option value="DarkSlateGray"></option>
											<option value="DarkSlateGrey"></option>
											<option value="DarkTurquoise"></option>
											<option value="DarkViolet"></option>
											<option value="DeepPink"></option>
											<option value="DeepSkyBlue"></option>
											<option value="DimGray"></option>
											<option value="DimGrey"></option>
											<option value="DodgerBlue"></option>
											<option value="FireBrick"></option>
											<option value="FloralWhite"></option>
											<option value="ForestGreen"></option>
											<option value="Fuchsia"></option>
											<option value="Gainsboro"></option>
											<option value="GhostWhite"></option>
											<option value="Gold"></option>
											<option value="GoldenRod"></option>
											<option value="Gray"></option>
											<option value="Grey"></option>
											<option value="Green"></option>
											<option value="GreenYellow"></option>
											<option value="HoneyDew"></option>
											<option value="LightGrey"></option>
											<option value="LightGreen"></option>
											<option value="LightPink"></option>
											<option value="LightSalmon"></option>
											<option value="LightSeaGreen"></option>
											<option value="LightSkyBlue"></option>
											<option value="LightSlateGray"></option>
											<option value="LightSlateGrey"></option>
											<option value="LightSteelBlue"></option>
											<option value="LightYellow"></option>
											<option value="Lime"></option>
											<option value="LimeGreen"></option>
											<option value="Linen"></option>
											<option value="Magenta"></option>
											<option value="Maroon"></option>
											<option value="MediumAquaMarine"></option>
											<option value="MediumBlue"></option>
											<option value="MediumOrchid"></option>
											<option value="MediumPurple"></option>
											<option value="MediumSeaGreen"></option>
											<option value="MediumSlateBlue"></option>
											<option value="MediumSpringGreen"></option>
											<option value="MediumTurquoise"></option>
											<option value="MediumVioletRed"></option>
											<option value="MidnightBlue"></option>
											<option value="MintCream"></option>
											<option value="MistyRose"></option>
											<option value="Moccasin"></option>
											<option value="NavajoWhite"></option>
											<option value="Navy"></option>
											<option value="OldLace"></option>
											<option value="Olive"></option>
											<option value="OliveDrab"></option>
											<option value="Orange"></option>
											<option value="OrangeRed"></option>
											<option value="Orchid"></option>
											<option value="PaleGoldenRod"></option>
											<option value="PaleGreen"></option>
											<option value="PaleTurquoise"></option>
											<option value="PaleVioletRed"></option>
											<option value="PapayaWhip"></option>
											<option value="Pink"></option>
											<option value="Plum"></option>
											<option value="PowderBlue"></option>
											<option value="Purple"></option>
											<option value="RebeccaPurple"></option>
											<option value="Red"></option>
											<option value="RosyBrown"></option>
											<option value="RoyalBlue"></option>
											<option value="SaddleBrown"></option>
											<option value="Salmon"></option>
											<option value="SandyBrown"></option>
											<option value="SeaGreen"></option>
											<option value="SeaShell"></option>
											<option value="Sienna"></option>
											<option value="Silver"></option>
											<option value="SkyBlue"></option>
											<option value="SlateBlue"></option>
											<option value="SlateGray"></option>
											<option value="SlateGrey"></option>
											<option value="Snow"></option>
											<option value="SpringGreen"></option>
											<option value="SteelBlue"></option>
											<option value="Tan"></option>
											<option value="Teal"></option>
											<option value="Thistle"></option>
											<option value="Tomato"></option>
											<option value="Turquoise"></option>
											<option value="Violet"></option>
											<option value="Wheat"></option>
											<option value="WhiteSmoke"></option>
											<option value="Yellow"></option>
											<option value="YellowGreen"></option>
										</select>
									</span>
									<span class="ql-formats">
										<button type="button" class="ql-strike" aria-label="Rayé"></button>
										<button type="button" class="ql-list" value="ordered" aria-label="Liste"></button>
										<button type="button" class="ql-list" value="bullet" aria-label="Puce"></button>
									</span>
									<span class="ql-formats">
										<button type="button" class="ql-link" aria-label="Lien"></button>
									</span>
								</ng-template>
							</p-editor>
						</div>

						<div class="form-group">
							<label class="ls-label-strong" for="mail-strongmsg">Info devis</label>
							<p-editor formControlName="emailInfoBillControl" [style]="{'height':'150px'}">
								<ng-template pTemplate="header">
									<span class="ql-formats">
										<button type="button" class="ql-bold" aria-label="Gras"></button>
										<button type="button" class="ql-italic" aria-label="Italique"></button>
										<button type="button" class="ql-underline" aria-label="Souligné"></button>
									</span>
									<span class="ql-formats">
										<select class="ql-color">
											<option value="Black"></option>
											<option value="White"></option>
											<option value="AliceBlue"></option>
											<option value="AntiqueWhite"></option>
											<option value="Aqua"></option>
											<option value="Aquamarine"></option>
											<option value="Azure"></option>
											<option value="Beige"></option>
											<option value="Bisque"></option>
											<option value="BlanchedAlmond"></option>
											<option value="Blue"></option>
											<option value="BlueViolet"></option>
											<option value="Brown"></option>
											<option value="BurlyWood"></option>
											<option value="CadetBlue"></option>
											<option value="Chartreuse"></option>
											<option value="Chocolate"></option>
											<option value="Coral"></option>
											<option value="CornflowerBlue"></option>
											<option value="Cornsilk"></option>
											<option value="Crimson"></option>
											<option value="Cyan"></option>
											<option value="DarkBlue"></option>
											<option value="DarkCyan"></option>
											<option value="DarkGoldenRod"></option>
											<option value="DarkGray"></option>
											<option value="DarkGrey"></option>
											<option value="DarkGreen"></option>
											<option value="DarkKhaki"></option>
											<option value="DarkMagenta"></option>
											<option value="DarkOliveGreen"></option>
											<option value="DarkOrange"></option>
											<option value="DarkOrchid"></option>
											<option value="DarkRed"></option>
											<option value="DarkSalmon"></option>
											<option value="DarkSeaGreen"></option>
											<option value="DarkSlateBlue"></option>
											<option value="DarkSlateGray"></option>
											<option value="DarkSlateGrey"></option>
											<option value="DarkTurquoise"></option>
											<option value="DarkViolet"></option>
											<option value="DeepPink"></option>
											<option value="DeepSkyBlue"></option>
											<option value="DimGray"></option>
											<option value="DimGrey"></option>
											<option value="DodgerBlue"></option>
											<option value="FireBrick"></option>
											<option value="FloralWhite"></option>
											<option value="ForestGreen"></option>
											<option value="Fuchsia"></option>
											<option value="Gainsboro"></option>
											<option value="GhostWhite"></option>
											<option value="Gold"></option>
											<option value="GoldenRod"></option>
											<option value="Gray"></option>
											<option value="Grey"></option>
											<option value="Green"></option>
											<option value="GreenYellow"></option>
											<option value="HoneyDew"></option>
											<option value="LightGrey"></option>
											<option value="LightGreen"></option>
											<option value="LightPink"></option>
											<option value="LightSalmon"></option>
											<option value="LightSeaGreen"></option>
											<option value="LightSkyBlue"></option>
											<option value="LightSlateGray"></option>
											<option value="LightSlateGrey"></option>
											<option value="LightSteelBlue"></option>
											<option value="LightYellow"></option>
											<option value="Lime"></option>
											<option value="LimeGreen"></option>
											<option value="Linen"></option>
											<option value="Magenta"></option>
											<option value="Maroon"></option>
											<option value="MediumAquaMarine"></option>
											<option value="MediumBlue"></option>
											<option value="MediumOrchid"></option>
											<option value="MediumPurple"></option>
											<option value="MediumSeaGreen"></option>
											<option value="MediumSlateBlue"></option>
											<option value="MediumSpringGreen"></option>
											<option value="MediumTurquoise"></option>
											<option value="MediumVioletRed"></option>
											<option value="MidnightBlue"></option>
											<option value="MintCream"></option>
											<option value="MistyRose"></option>
											<option value="Moccasin"></option>
											<option value="NavajoWhite"></option>
											<option value="Navy"></option>
											<option value="OldLace"></option>
											<option value="Olive"></option>
											<option value="OliveDrab"></option>
											<option value="Orange"></option>
											<option value="OrangeRed"></option>
											<option value="Orchid"></option>
											<option value="PaleGoldenRod"></option>
											<option value="PaleGreen"></option>
											<option value="PaleTurquoise"></option>
											<option value="PaleVioletRed"></option>
											<option value="PapayaWhip"></option>
											<option value="Pink"></option>
											<option value="Plum"></option>
											<option value="PowderBlue"></option>
											<option value="Purple"></option>
											<option value="RebeccaPurple"></option>
											<option value="Red"></option>
											<option value="RosyBrown"></option>
											<option value="RoyalBlue"></option>
											<option value="SaddleBrown"></option>
											<option value="Salmon"></option>
											<option value="SandyBrown"></option>
											<option value="SeaGreen"></option>
											<option value="SeaShell"></option>
											<option value="Sienna"></option>
											<option value="Silver"></option>
											<option value="SkyBlue"></option>
											<option value="SlateBlue"></option>
											<option value="SlateGray"></option>
											<option value="SlateGrey"></option>
											<option value="Snow"></option>
											<option value="SpringGreen"></option>
											<option value="SteelBlue"></option>
											<option value="Tan"></option>
											<option value="Teal"></option>
											<option value="Thistle"></option>
											<option value="Tomato"></option>
											<option value="Turquoise"></option>
											<option value="Violet"></option>
											<option value="Wheat"></option>
											<option value="WhiteSmoke"></option>
											<option value="Yellow"></option>
											<option value="YellowGreen"></option>
										</select>
										<select class="ql-background">
											<option value="Black"></option>
											<option value="White"></option>
											<option value="AliceBlue"></option>
											<option value="AntiqueWhite"></option>
											<option value="Aqua"></option>
											<option value="Aquamarine"></option>
											<option value="Azure"></option>
											<option value="Beige"></option>
											<option value="Bisque"></option>
											<option value="BlanchedAlmond"></option>
											<option value="Blue"></option>
											<option value="BlueViolet"></option>
											<option value="Brown"></option>
											<option value="BurlyWood"></option>
											<option value="CadetBlue"></option>
											<option value="Chartreuse"></option>
											<option value="Chocolate"></option>
											<option value="Coral"></option>
											<option value="CornflowerBlue"></option>
											<option value="Cornsilk"></option>
											<option value="Crimson"></option>
											<option value="Cyan"></option>
											<option value="DarkBlue"></option>
											<option value="DarkCyan"></option>
											<option value="DarkGoldenRod"></option>
											<option value="DarkGray"></option>
											<option value="DarkGrey"></option>
											<option value="DarkGreen"></option>
											<option value="DarkKhaki"></option>
											<option value="DarkMagenta"></option>
											<option value="DarkOliveGreen"></option>
											<option value="DarkOrange"></option>
											<option value="DarkOrchid"></option>
											<option value="DarkRed"></option>
											<option value="DarkSalmon"></option>
											<option value="DarkSeaGreen"></option>
											<option value="DarkSlateBlue"></option>
											<option value="DarkSlateGray"></option>
											<option value="DarkSlateGrey"></option>
											<option value="DarkTurquoise"></option>
											<option value="DarkViolet"></option>
											<option value="DeepPink"></option>
											<option value="DeepSkyBlue"></option>
											<option value="DimGray"></option>
											<option value="DimGrey"></option>
											<option value="DodgerBlue"></option>
											<option value="FireBrick"></option>
											<option value="FloralWhite"></option>
											<option value="ForestGreen"></option>
											<option value="Fuchsia"></option>
											<option value="Gainsboro"></option>
											<option value="GhostWhite"></option>
											<option value="Gold"></option>
											<option value="GoldenRod"></option>
											<option value="Gray"></option>
											<option value="Grey"></option>
											<option value="Green"></option>
											<option value="GreenYellow"></option>
											<option value="HoneyDew"></option>
											<option value="LightGrey"></option>
											<option value="LightGreen"></option>
											<option value="LightPink"></option>
											<option value="LightSalmon"></option>
											<option value="LightSeaGreen"></option>
											<option value="LightSkyBlue"></option>
											<option value="LightSlateGray"></option>
											<option value="LightSlateGrey"></option>
											<option value="LightSteelBlue"></option>
											<option value="LightYellow"></option>
											<option value="Lime"></option>
											<option value="LimeGreen"></option>
											<option value="Linen"></option>
											<option value="Magenta"></option>
											<option value="Maroon"></option>
											<option value="MediumAquaMarine"></option>
											<option value="MediumBlue"></option>
											<option value="MediumOrchid"></option>
											<option value="MediumPurple"></option>
											<option value="MediumSeaGreen"></option>
											<option value="MediumSlateBlue"></option>
											<option value="MediumSpringGreen"></option>
											<option value="MediumTurquoise"></option>
											<option value="MediumVioletRed"></option>
											<option value="MidnightBlue"></option>
											<option value="MintCream"></option>
											<option value="MistyRose"></option>
											<option value="Moccasin"></option>
											<option value="NavajoWhite"></option>
											<option value="Navy"></option>
											<option value="OldLace"></option>
											<option value="Olive"></option>
											<option value="OliveDrab"></option>
											<option value="Orange"></option>
											<option value="OrangeRed"></option>
											<option value="Orchid"></option>
											<option value="PaleGoldenRod"></option>
											<option value="PaleGreen"></option>
											<option value="PaleTurquoise"></option>
											<option value="PaleVioletRed"></option>
											<option value="PapayaWhip"></option>
											<option value="Pink"></option>
											<option value="Plum"></option>
											<option value="PowderBlue"></option>
											<option value="Purple"></option>
											<option value="RebeccaPurple"></option>
											<option value="Red"></option>
											<option value="RosyBrown"></option>
											<option value="RoyalBlue"></option>
											<option value="SaddleBrown"></option>
											<option value="Salmon"></option>
											<option value="SandyBrown"></option>
											<option value="SeaGreen"></option>
											<option value="SeaShell"></option>
											<option value="Sienna"></option>
											<option value="Silver"></option>
											<option value="SkyBlue"></option>
											<option value="SlateBlue"></option>
											<option value="SlateGray"></option>
											<option value="SlateGrey"></option>
											<option value="Snow"></option>
											<option value="SpringGreen"></option>
											<option value="SteelBlue"></option>
											<option value="Tan"></option>
											<option value="Teal"></option>
											<option value="Thistle"></option>
											<option value="Tomato"></option>
											<option value="Turquoise"></option>
											<option value="Violet"></option>
											<option value="Wheat"></option>
											<option value="WhiteSmoke"></option>
											<option value="Yellow"></option>
											<option value="YellowGreen"></option>
										</select>
									</span>
									<span class="ql-formats">
										<button type="button" class="ql-strike" aria-label="Rayé"></button>
										<button type="button" class="ql-list" value="ordered" aria-label="Liste"></button>
										<button type="button" class="ql-list" value="bullet" aria-label="Puce"></button>
									</span>
									<span class="ql-formats">
										<button type="button" class="ql-link" aria-label="Lien"></button>
									</span>
								</ng-template>
							</p-editor>
						</div>

						<div class="form-group">
							<label class="ls-label-strong" for="mail-answer">Info réponse</label>
							<p-editor formControlName="emailInfoAnswerControl" [style]="{'height':'150px'}">
								<ng-template pTemplate="header">
									<span class="ql-formats">
										<button type="button" class="ql-bold" aria-label="Gras"></button>
										<button type="button" class="ql-italic" aria-label="Italique"></button>
										<button type="button" class="ql-underline" aria-label="Souligné"></button>
									</span>
									<span class="ql-formats">
										<select class="ql-color">
											<option value="Black"></option>
											<option value="White"></option>
											<option value="AliceBlue"></option>
											<option value="AntiqueWhite"></option>
											<option value="Aqua"></option>
											<option value="Aquamarine"></option>
											<option value="Azure"></option>
											<option value="Beige"></option>
											<option value="Bisque"></option>
											<option value="BlanchedAlmond"></option>
											<option value="Blue"></option>
											<option value="BlueViolet"></option>
											<option value="Brown"></option>
											<option value="BurlyWood"></option>
											<option value="CadetBlue"></option>
											<option value="Chartreuse"></option>
											<option value="Chocolate"></option>
											<option value="Coral"></option>
											<option value="CornflowerBlue"></option>
											<option value="Cornsilk"></option>
											<option value="Crimson"></option>
											<option value="Cyan"></option>
											<option value="DarkBlue"></option>
											<option value="DarkCyan"></option>
											<option value="DarkGoldenRod"></option>
											<option value="DarkGray"></option>
											<option value="DarkGrey"></option>
											<option value="DarkGreen"></option>
											<option value="DarkKhaki"></option>
											<option value="DarkMagenta"></option>
											<option value="DarkOliveGreen"></option>
											<option value="DarkOrange"></option>
											<option value="DarkOrchid"></option>
											<option value="DarkRed"></option>
											<option value="DarkSalmon"></option>
											<option value="DarkSeaGreen"></option>
											<option value="DarkSlateBlue"></option>
											<option value="DarkSlateGray"></option>
											<option value="DarkSlateGrey"></option>
											<option value="DarkTurquoise"></option>
											<option value="DarkViolet"></option>
											<option value="DeepPink"></option>
											<option value="DeepSkyBlue"></option>
											<option value="DimGray"></option>
											<option value="DimGrey"></option>
											<option value="DodgerBlue"></option>
											<option value="FireBrick"></option>
											<option value="FloralWhite"></option>
											<option value="ForestGreen"></option>
											<option value="Fuchsia"></option>
											<option value="Gainsboro"></option>
											<option value="GhostWhite"></option>
											<option value="Gold"></option>
											<option value="GoldenRod"></option>
											<option value="Gray"></option>
											<option value="Grey"></option>
											<option value="Green"></option>
											<option value="GreenYellow"></option>
											<option value="HoneyDew"></option>
											<option value="LightGrey"></option>
											<option value="LightGreen"></option>
											<option value="LightPink"></option>
											<option value="LightSalmon"></option>
											<option value="LightSeaGreen"></option>
											<option value="LightSkyBlue"></option>
											<option value="LightSlateGray"></option>
											<option value="LightSlateGrey"></option>
											<option value="LightSteelBlue"></option>
											<option value="LightYellow"></option>
											<option value="Lime"></option>
											<option value="LimeGreen"></option>
											<option value="Linen"></option>
											<option value="Magenta"></option>
											<option value="Maroon"></option>
											<option value="MediumAquaMarine"></option>
											<option value="MediumBlue"></option>
											<option value="MediumOrchid"></option>
											<option value="MediumPurple"></option>
											<option value="MediumSeaGreen"></option>
											<option value="MediumSlateBlue"></option>
											<option value="MediumSpringGreen"></option>
											<option value="MediumTurquoise"></option>
											<option value="MediumVioletRed"></option>
											<option value="MidnightBlue"></option>
											<option value="MintCream"></option>
											<option value="MistyRose"></option>
											<option value="Moccasin"></option>
											<option value="NavajoWhite"></option>
											<option value="Navy"></option>
											<option value="OldLace"></option>
											<option value="Olive"></option>
											<option value="OliveDrab"></option>
											<option value="Orange"></option>
											<option value="OrangeRed"></option>
											<option value="Orchid"></option>
											<option value="PaleGoldenRod"></option>
											<option value="PaleGreen"></option>
											<option value="PaleTurquoise"></option>
											<option value="PaleVioletRed"></option>
											<option value="PapayaWhip"></option>
											<option value="Pink"></option>
											<option value="Plum"></option>
											<option value="PowderBlue"></option>
											<option value="Purple"></option>
											<option value="RebeccaPurple"></option>
											<option value="Red"></option>
											<option value="RosyBrown"></option>
											<option value="RoyalBlue"></option>
											<option value="SaddleBrown"></option>
											<option value="Salmon"></option>
											<option value="SandyBrown"></option>
											<option value="SeaGreen"></option>
											<option value="SeaShell"></option>
											<option value="Sienna"></option>
											<option value="Silver"></option>
											<option value="SkyBlue"></option>
											<option value="SlateBlue"></option>
											<option value="SlateGray"></option>
											<option value="SlateGrey"></option>
											<option value="Snow"></option>
											<option value="SpringGreen"></option>
											<option value="SteelBlue"></option>
											<option value="Tan"></option>
											<option value="Teal"></option>
											<option value="Thistle"></option>
											<option value="Tomato"></option>
											<option value="Turquoise"></option>
											<option value="Violet"></option>
											<option value="Wheat"></option>
											<option value="WhiteSmoke"></option>
											<option value="Yellow"></option>
											<option value="YellowGreen"></option>
										</select>
										<select class="ql-background">
											<option value="Black"></option>
											<option value="White"></option>
											<option value="AliceBlue"></option>
											<option value="AntiqueWhite"></option>
											<option value="Aqua"></option>
											<option value="Aquamarine"></option>
											<option value="Azure"></option>
											<option value="Beige"></option>
											<option value="Bisque"></option>
											<option value="BlanchedAlmond"></option>
											<option value="Blue"></option>
											<option value="BlueViolet"></option>
											<option value="Brown"></option>
											<option value="BurlyWood"></option>
											<option value="CadetBlue"></option>
											<option value="Chartreuse"></option>
											<option value="Chocolate"></option>
											<option value="Coral"></option>
											<option value="CornflowerBlue"></option>
											<option value="Cornsilk"></option>
											<option value="Crimson"></option>
											<option value="Cyan"></option>
											<option value="DarkBlue"></option>
											<option value="DarkCyan"></option>
											<option value="DarkGoldenRod"></option>
											<option value="DarkGray"></option>
											<option value="DarkGrey"></option>
											<option value="DarkGreen"></option>
											<option value="DarkKhaki"></option>
											<option value="DarkMagenta"></option>
											<option value="DarkOliveGreen"></option>
											<option value="DarkOrange"></option>
											<option value="DarkOrchid"></option>
											<option value="DarkRed"></option>
											<option value="DarkSalmon"></option>
											<option value="DarkSeaGreen"></option>
											<option value="DarkSlateBlue"></option>
											<option value="DarkSlateGray"></option>
											<option value="DarkSlateGrey"></option>
											<option value="DarkTurquoise"></option>
											<option value="DarkViolet"></option>
											<option value="DeepPink"></option>
											<option value="DeepSkyBlue"></option>
											<option value="DimGray"></option>
											<option value="DimGrey"></option>
											<option value="DodgerBlue"></option>
											<option value="FireBrick"></option>
											<option value="FloralWhite"></option>
											<option value="ForestGreen"></option>
											<option value="Fuchsia"></option>
											<option value="Gainsboro"></option>
											<option value="GhostWhite"></option>
											<option value="Gold"></option>
											<option value="GoldenRod"></option>
											<option value="Gray"></option>
											<option value="Grey"></option>
											<option value="Green"></option>
											<option value="GreenYellow"></option>
											<option value="HoneyDew"></option>
											<option value="LightGrey"></option>
											<option value="LightGreen"></option>
											<option value="LightPink"></option>
											<option value="LightSalmon"></option>
											<option value="LightSeaGreen"></option>
											<option value="LightSkyBlue"></option>
											<option value="LightSlateGray"></option>
											<option value="LightSlateGrey"></option>
											<option value="LightSteelBlue"></option>
											<option value="LightYellow"></option>
											<option value="Lime"></option>
											<option value="LimeGreen"></option>
											<option value="Linen"></option>
											<option value="Magenta"></option>
											<option value="Maroon"></option>
											<option value="MediumAquaMarine"></option>
											<option value="MediumBlue"></option>
											<option value="MediumOrchid"></option>
											<option value="MediumPurple"></option>
											<option value="MediumSeaGreen"></option>
											<option value="MediumSlateBlue"></option>
											<option value="MediumSpringGreen"></option>
											<option value="MediumTurquoise"></option>
											<option value="MediumVioletRed"></option>
											<option value="MidnightBlue"></option>
											<option value="MintCream"></option>
											<option value="MistyRose"></option>
											<option value="Moccasin"></option>
											<option value="NavajoWhite"></option>
											<option value="Navy"></option>
											<option value="OldLace"></option>
											<option value="Olive"></option>
											<option value="OliveDrab"></option>
											<option value="Orange"></option>
											<option value="OrangeRed"></option>
											<option value="Orchid"></option>
											<option value="PaleGoldenRod"></option>
											<option value="PaleGreen"></option>
											<option value="PaleTurquoise"></option>
											<option value="PaleVioletRed"></option>
											<option value="PapayaWhip"></option>
											<option value="Pink"></option>
											<option value="Plum"></option>
											<option value="PowderBlue"></option>
											<option value="Purple"></option>
											<option value="RebeccaPurple"></option>
											<option value="Red"></option>
											<option value="RosyBrown"></option>
											<option value="RoyalBlue"></option>
											<option value="SaddleBrown"></option>
											<option value="Salmon"></option>
											<option value="SandyBrown"></option>
											<option value="SeaGreen"></option>
											<option value="SeaShell"></option>
											<option value="Sienna"></option>
											<option value="Silver"></option>
											<option value="SkyBlue"></option>
											<option value="SlateBlue"></option>
											<option value="SlateGray"></option>
											<option value="SlateGrey"></option>
											<option value="Snow"></option>
											<option value="SpringGreen"></option>
											<option value="SteelBlue"></option>
											<option value="Tan"></option>
											<option value="Teal"></option>
											<option value="Thistle"></option>
											<option value="Tomato"></option>
											<option value="Turquoise"></option>
											<option value="Violet"></option>
											<option value="Wheat"></option>
											<option value="WhiteSmoke"></option>
											<option value="Yellow"></option>
											<option value="YellowGreen"></option>
										</select>
									</span>
									<span class="ql-formats">
										<button type="button" class="ql-strike" aria-label="Rayé"></button>
										<button type="button" class="ql-list" value="ordered" aria-label="Liste"></button>
										<button type="button" class="ql-list" value="bullet" aria-label="Puce"></button>
									</span>
									<span class="ql-formats">
										<button type="button" class="ql-link" aria-label="Lien"></button>
									</span>
								</ng-template>
							</p-editor>
						</div>

						<div class="form-group">
							<label class="ls-label-strong" for="mail-nota">Nota</label>
							<p-editor formControlName="emailNotaControl" [style]="{'height':'150px'}">
								<ng-template pTemplate="header">
									<span class="ql-formats">
										<button type="button" class="ql-bold" aria-label="Gras"></button>
										<button type="button" class="ql-italic" aria-label="Italique"></button>
										<button type="button" class="ql-underline" aria-label="Souligné"></button>
									</span>
									<span class="ql-formats">
										<select class="ql-color">
											<option value="Black"></option>
											<option value="White"></option>
											<option value="AliceBlue"></option>
											<option value="AntiqueWhite"></option>
											<option value="Aqua"></option>
											<option value="Aquamarine"></option>
											<option value="Azure"></option>
											<option value="Beige"></option>
											<option value="Bisque"></option>
											<option value="BlanchedAlmond"></option>
											<option value="Blue"></option>
											<option value="BlueViolet"></option>
											<option value="Brown"></option>
											<option value="BurlyWood"></option>
											<option value="CadetBlue"></option>
											<option value="Chartreuse"></option>
											<option value="Chocolate"></option>
											<option value="Coral"></option>
											<option value="CornflowerBlue"></option>
											<option value="Cornsilk"></option>
											<option value="Crimson"></option>
											<option value="Cyan"></option>
											<option value="DarkBlue"></option>
											<option value="DarkCyan"></option>
											<option value="DarkGoldenRod"></option>
											<option value="DarkGray"></option>
											<option value="DarkGrey"></option>
											<option value="DarkGreen"></option>
											<option value="DarkKhaki"></option>
											<option value="DarkMagenta"></option>
											<option value="DarkOliveGreen"></option>
											<option value="DarkOrange"></option>
											<option value="DarkOrchid"></option>
											<option value="DarkRed"></option>
											<option value="DarkSalmon"></option>
											<option value="DarkSeaGreen"></option>
											<option value="DarkSlateBlue"></option>
											<option value="DarkSlateGray"></option>
											<option value="DarkSlateGrey"></option>
											<option value="DarkTurquoise"></option>
											<option value="DarkViolet"></option>
											<option value="DeepPink"></option>
											<option value="DeepSkyBlue"></option>
											<option value="DimGray"></option>
											<option value="DimGrey"></option>
											<option value="DodgerBlue"></option>
											<option value="FireBrick"></option>
											<option value="FloralWhite"></option>
											<option value="ForestGreen"></option>
											<option value="Fuchsia"></option>
											<option value="Gainsboro"></option>
											<option value="GhostWhite"></option>
											<option value="Gold"></option>
											<option value="GoldenRod"></option>
											<option value="Gray"></option>
											<option value="Grey"></option>
											<option value="Green"></option>
											<option value="GreenYellow"></option>
											<option value="HoneyDew"></option>
											<option value="LightGrey"></option>
											<option value="LightGreen"></option>
											<option value="LightPink"></option>
											<option value="LightSalmon"></option>
											<option value="LightSeaGreen"></option>
											<option value="LightSkyBlue"></option>
											<option value="LightSlateGray"></option>
											<option value="LightSlateGrey"></option>
											<option value="LightSteelBlue"></option>
											<option value="LightYellow"></option>
											<option value="Lime"></option>
											<option value="LimeGreen"></option>
											<option value="Linen"></option>
											<option value="Magenta"></option>
											<option value="Maroon"></option>
											<option value="MediumAquaMarine"></option>
											<option value="MediumBlue"></option>
											<option value="MediumOrchid"></option>
											<option value="MediumPurple"></option>
											<option value="MediumSeaGreen"></option>
											<option value="MediumSlateBlue"></option>
											<option value="MediumSpringGreen"></option>
											<option value="MediumTurquoise"></option>
											<option value="MediumVioletRed"></option>
											<option value="MidnightBlue"></option>
											<option value="MintCream"></option>
											<option value="MistyRose"></option>
											<option value="Moccasin"></option>
											<option value="NavajoWhite"></option>
											<option value="Navy"></option>
											<option value="OldLace"></option>
											<option value="Olive"></option>
											<option value="OliveDrab"></option>
											<option value="Orange"></option>
											<option value="OrangeRed"></option>
											<option value="Orchid"></option>
											<option value="PaleGoldenRod"></option>
											<option value="PaleGreen"></option>
											<option value="PaleTurquoise"></option>
											<option value="PaleVioletRed"></option>
											<option value="PapayaWhip"></option>
											<option value="Pink"></option>
											<option value="Plum"></option>
											<option value="PowderBlue"></option>
											<option value="Purple"></option>
											<option value="RebeccaPurple"></option>
											<option value="Red"></option>
											<option value="RosyBrown"></option>
											<option value="RoyalBlue"></option>
											<option value="SaddleBrown"></option>
											<option value="Salmon"></option>
											<option value="SandyBrown"></option>
											<option value="SeaGreen"></option>
											<option value="SeaShell"></option>
											<option value="Sienna"></option>
											<option value="Silver"></option>
											<option value="SkyBlue"></option>
											<option value="SlateBlue"></option>
											<option value="SlateGray"></option>
											<option value="SlateGrey"></option>
											<option value="Snow"></option>
											<option value="SpringGreen"></option>
											<option value="SteelBlue"></option>
											<option value="Tan"></option>
											<option value="Teal"></option>
											<option value="Thistle"></option>
											<option value="Tomato"></option>
											<option value="Turquoise"></option>
											<option value="Violet"></option>
											<option value="Wheat"></option>
											<option value="WhiteSmoke"></option>
											<option value="Yellow"></option>
											<option value="YellowGreen"></option>
										</select>
										<select class="ql-background">
											<option value="Black"></option>
											<option value="White"></option>
											<option value="AliceBlue"></option>
											<option value="AntiqueWhite"></option>
											<option value="Aqua"></option>
											<option value="Aquamarine"></option>
											<option value="Azure"></option>
											<option value="Beige"></option>
											<option value="Bisque"></option>
											<option value="BlanchedAlmond"></option>
											<option value="Blue"></option>
											<option value="BlueViolet"></option>
											<option value="Brown"></option>
											<option value="BurlyWood"></option>
											<option value="CadetBlue"></option>
											<option value="Chartreuse"></option>
											<option value="Chocolate"></option>
											<option value="Coral"></option>
											<option value="CornflowerBlue"></option>
											<option value="Cornsilk"></option>
											<option value="Crimson"></option>
											<option value="Cyan"></option>
											<option value="DarkBlue"></option>
											<option value="DarkCyan"></option>
											<option value="DarkGoldenRod"></option>
											<option value="DarkGray"></option>
											<option value="DarkGrey"></option>
											<option value="DarkGreen"></option>
											<option value="DarkKhaki"></option>
											<option value="DarkMagenta"></option>
											<option value="DarkOliveGreen"></option>
											<option value="DarkOrange"></option>
											<option value="DarkOrchid"></option>
											<option value="DarkRed"></option>
											<option value="DarkSalmon"></option>
											<option value="DarkSeaGreen"></option>
											<option value="DarkSlateBlue"></option>
											<option value="DarkSlateGray"></option>
											<option value="DarkSlateGrey"></option>
											<option value="DarkTurquoise"></option>
											<option value="DarkViolet"></option>
											<option value="DeepPink"></option>
											<option value="DeepSkyBlue"></option>
											<option value="DimGray"></option>
											<option value="DimGrey"></option>
											<option value="DodgerBlue"></option>
											<option value="FireBrick"></option>
											<option value="FloralWhite"></option>
											<option value="ForestGreen"></option>
											<option value="Fuchsia"></option>
											<option value="Gainsboro"></option>
											<option value="GhostWhite"></option>
											<option value="Gold"></option>
											<option value="GoldenRod"></option>
											<option value="Gray"></option>
											<option value="Grey"></option>
											<option value="Green"></option>
											<option value="GreenYellow"></option>
											<option value="HoneyDew"></option>
											<option value="LightGrey"></option>
											<option value="LightGreen"></option>
											<option value="LightPink"></option>
											<option value="LightSalmon"></option>
											<option value="LightSeaGreen"></option>
											<option value="LightSkyBlue"></option>
											<option value="LightSlateGray"></option>
											<option value="LightSlateGrey"></option>
											<option value="LightSteelBlue"></option>
											<option value="LightYellow"></option>
											<option value="Lime"></option>
											<option value="LimeGreen"></option>
											<option value="Linen"></option>
											<option value="Magenta"></option>
											<option value="Maroon"></option>
											<option value="MediumAquaMarine"></option>
											<option value="MediumBlue"></option>
											<option value="MediumOrchid"></option>
											<option value="MediumPurple"></option>
											<option value="MediumSeaGreen"></option>
											<option value="MediumSlateBlue"></option>
											<option value="MediumSpringGreen"></option>
											<option value="MediumTurquoise"></option>
											<option value="MediumVioletRed"></option>
											<option value="MidnightBlue"></option>
											<option value="MintCream"></option>
											<option value="MistyRose"></option>
											<option value="Moccasin"></option>
											<option value="NavajoWhite"></option>
											<option value="Navy"></option>
											<option value="OldLace"></option>
											<option value="Olive"></option>
											<option value="OliveDrab"></option>
											<option value="Orange"></option>
											<option value="OrangeRed"></option>
											<option value="Orchid"></option>
											<option value="PaleGoldenRod"></option>
											<option value="PaleGreen"></option>
											<option value="PaleTurquoise"></option>
											<option value="PaleVioletRed"></option>
											<option value="PapayaWhip"></option>
											<option value="Pink"></option>
											<option value="Plum"></option>
											<option value="PowderBlue"></option>
											<option value="Purple"></option>
											<option value="RebeccaPurple"></option>
											<option value="Red"></option>
											<option value="RosyBrown"></option>
											<option value="RoyalBlue"></option>
											<option value="SaddleBrown"></option>
											<option value="Salmon"></option>
											<option value="SandyBrown"></option>
											<option value="SeaGreen"></option>
											<option value="SeaShell"></option>
											<option value="Sienna"></option>
											<option value="Silver"></option>
											<option value="SkyBlue"></option>
											<option value="SlateBlue"></option>
											<option value="SlateGray"></option>
											<option value="SlateGrey"></option>
											<option value="Snow"></option>
											<option value="SpringGreen"></option>
											<option value="SteelBlue"></option>
											<option value="Tan"></option>
											<option value="Teal"></option>
											<option value="Thistle"></option>
											<option value="Tomato"></option>
											<option value="Turquoise"></option>
											<option value="Violet"></option>
											<option value="Wheat"></option>
											<option value="WhiteSmoke"></option>
											<option value="Yellow"></option>
											<option value="YellowGreen"></option>
										</select>
									</span>
									<span class="ql-formats">
										<button type="button" class="ql-strike" aria-label="Rayé"></button>
										<button type="button" class="ql-list" value="ordered" aria-label="Liste"></button>
										<button type="button" class="ql-list" value="bullet" aria-label="Puce"></button>
									</span>
									<span class="ql-formats">
										<button type="button" class="ql-link" aria-label="Lien"></button>
									</span>
								</ng-template>
							</p-editor>
						</div>

						<div class="form-group">
							<label class="ls-label-strong" for="mail-link">Lien accord / désaccord</label>
							<p-editor formControlName="emailLinkValidControl" [style]="{'height':'150px'}">
								<ng-template pTemplate="header">
									<span class="ql-formats">
										<button type="button" class="ql-bold" aria-label="Gras"></button>
										<button type="button" class="ql-italic" aria-label="Italique"></button>
										<button type="button" class="ql-underline" aria-label="Souligné"></button>
									</span>
									<span class="ql-formats">
										<select class="ql-color">
											<option value="Black"></option>
											<option value="White"></option>
											<option value="AliceBlue"></option>
											<option value="AntiqueWhite"></option>
											<option value="Aqua"></option>
											<option value="Aquamarine"></option>
											<option value="Azure"></option>
											<option value="Beige"></option>
											<option value="Bisque"></option>
											<option value="BlanchedAlmond"></option>
											<option value="Blue"></option>
											<option value="BlueViolet"></option>
											<option value="Brown"></option>
											<option value="BurlyWood"></option>
											<option value="CadetBlue"></option>
											<option value="Chartreuse"></option>
											<option value="Chocolate"></option>
											<option value="Coral"></option>
											<option value="CornflowerBlue"></option>
											<option value="Cornsilk"></option>
											<option value="Crimson"></option>
											<option value="Cyan"></option>
											<option value="DarkBlue"></option>
											<option value="DarkCyan"></option>
											<option value="DarkGoldenRod"></option>
											<option value="DarkGray"></option>
											<option value="DarkGrey"></option>
											<option value="DarkGreen"></option>
											<option value="DarkKhaki"></option>
											<option value="DarkMagenta"></option>
											<option value="DarkOliveGreen"></option>
											<option value="DarkOrange"></option>
											<option value="DarkOrchid"></option>
											<option value="DarkRed"></option>
											<option value="DarkSalmon"></option>
											<option value="DarkSeaGreen"></option>
											<option value="DarkSlateBlue"></option>
											<option value="DarkSlateGray"></option>
											<option value="DarkSlateGrey"></option>
											<option value="DarkTurquoise"></option>
											<option value="DarkViolet"></option>
											<option value="DeepPink"></option>
											<option value="DeepSkyBlue"></option>
											<option value="DimGray"></option>
											<option value="DimGrey"></option>
											<option value="DodgerBlue"></option>
											<option value="FireBrick"></option>
											<option value="FloralWhite"></option>
											<option value="ForestGreen"></option>
											<option value="Fuchsia"></option>
											<option value="Gainsboro"></option>
											<option value="GhostWhite"></option>
											<option value="Gold"></option>
											<option value="GoldenRod"></option>
											<option value="Gray"></option>
											<option value="Grey"></option>
											<option value="Green"></option>
											<option value="GreenYellow"></option>
											<option value="HoneyDew"></option>
											<option value="LightGrey"></option>
											<option value="LightGreen"></option>
											<option value="LightPink"></option>
											<option value="LightSalmon"></option>
											<option value="LightSeaGreen"></option>
											<option value="LightSkyBlue"></option>
											<option value="LightSlateGray"></option>
											<option value="LightSlateGrey"></option>
											<option value="LightSteelBlue"></option>
											<option value="LightYellow"></option>
											<option value="Lime"></option>
											<option value="LimeGreen"></option>
											<option value="Linen"></option>
											<option value="Magenta"></option>
											<option value="Maroon"></option>
											<option value="MediumAquaMarine"></option>
											<option value="MediumBlue"></option>
											<option value="MediumOrchid"></option>
											<option value="MediumPurple"></option>
											<option value="MediumSeaGreen"></option>
											<option value="MediumSlateBlue"></option>
											<option value="MediumSpringGreen"></option>
											<option value="MediumTurquoise"></option>
											<option value="MediumVioletRed"></option>
											<option value="MidnightBlue"></option>
											<option value="MintCream"></option>
											<option value="MistyRose"></option>
											<option value="Moccasin"></option>
											<option value="NavajoWhite"></option>
											<option value="Navy"></option>
											<option value="OldLace"></option>
											<option value="Olive"></option>
											<option value="OliveDrab"></option>
											<option value="Orange"></option>
											<option value="OrangeRed"></option>
											<option value="Orchid"></option>
											<option value="PaleGoldenRod"></option>
											<option value="PaleGreen"></option>
											<option value="PaleTurquoise"></option>
											<option value="PaleVioletRed"></option>
											<option value="PapayaWhip"></option>
											<option value="Pink"></option>
											<option value="Plum"></option>
											<option value="PowderBlue"></option>
											<option value="Purple"></option>
											<option value="RebeccaPurple"></option>
											<option value="Red"></option>
											<option value="RosyBrown"></option>
											<option value="RoyalBlue"></option>
											<option value="SaddleBrown"></option>
											<option value="Salmon"></option>
											<option value="SandyBrown"></option>
											<option value="SeaGreen"></option>
											<option value="SeaShell"></option>
											<option value="Sienna"></option>
											<option value="Silver"></option>
											<option value="SkyBlue"></option>
											<option value="SlateBlue"></option>
											<option value="SlateGray"></option>
											<option value="SlateGrey"></option>
											<option value="Snow"></option>
											<option value="SpringGreen"></option>
											<option value="SteelBlue"></option>
											<option value="Tan"></option>
											<option value="Teal"></option>
											<option value="Thistle"></option>
											<option value="Tomato"></option>
											<option value="Turquoise"></option>
											<option value="Violet"></option>
											<option value="Wheat"></option>
											<option value="WhiteSmoke"></option>
											<option value="Yellow"></option>
											<option value="YellowGreen"></option>
										</select>
										<select class="ql-background">
											<option value="Black"></option>
											<option value="White"></option>
											<option value="AliceBlue"></option>
											<option value="AntiqueWhite"></option>
											<option value="Aqua"></option>
											<option value="Aquamarine"></option>
											<option value="Azure"></option>
											<option value="Beige"></option>
											<option value="Bisque"></option>
											<option value="BlanchedAlmond"></option>
											<option value="Blue"></option>
											<option value="BlueViolet"></option>
											<option value="Brown"></option>
											<option value="BurlyWood"></option>
											<option value="CadetBlue"></option>
											<option value="Chartreuse"></option>
											<option value="Chocolate"></option>
											<option value="Coral"></option>
											<option value="CornflowerBlue"></option>
											<option value="Cornsilk"></option>
											<option value="Crimson"></option>
											<option value="Cyan"></option>
											<option value="DarkBlue"></option>
											<option value="DarkCyan"></option>
											<option value="DarkGoldenRod"></option>
											<option value="DarkGray"></option>
											<option value="DarkGrey"></option>
											<option value="DarkGreen"></option>
											<option value="DarkKhaki"></option>
											<option value="DarkMagenta"></option>
											<option value="DarkOliveGreen"></option>
											<option value="DarkOrange"></option>
											<option value="DarkOrchid"></option>
											<option value="DarkRed"></option>
											<option value="DarkSalmon"></option>
											<option value="DarkSeaGreen"></option>
											<option value="DarkSlateBlue"></option>
											<option value="DarkSlateGray"></option>
											<option value="DarkSlateGrey"></option>
											<option value="DarkTurquoise"></option>
											<option value="DarkViolet"></option>
											<option value="DeepPink"></option>
											<option value="DeepSkyBlue"></option>
											<option value="DimGray"></option>
											<option value="DimGrey"></option>
											<option value="DodgerBlue"></option>
											<option value="FireBrick"></option>
											<option value="FloralWhite"></option>
											<option value="ForestGreen"></option>
											<option value="Fuchsia"></option>
											<option value="Gainsboro"></option>
											<option value="GhostWhite"></option>
											<option value="Gold"></option>
											<option value="GoldenRod"></option>
											<option value="Gray"></option>
											<option value="Grey"></option>
											<option value="Green"></option>
											<option value="GreenYellow"></option>
											<option value="HoneyDew"></option>
											<option value="LightGrey"></option>
											<option value="LightGreen"></option>
											<option value="LightPink"></option>
											<option value="LightSalmon"></option>
											<option value="LightSeaGreen"></option>
											<option value="LightSkyBlue"></option>
											<option value="LightSlateGray"></option>
											<option value="LightSlateGrey"></option>
											<option value="LightSteelBlue"></option>
											<option value="LightYellow"></option>
											<option value="Lime"></option>
											<option value="LimeGreen"></option>
											<option value="Linen"></option>
											<option value="Magenta"></option>
											<option value="Maroon"></option>
											<option value="MediumAquaMarine"></option>
											<option value="MediumBlue"></option>
											<option value="MediumOrchid"></option>
											<option value="MediumPurple"></option>
											<option value="MediumSeaGreen"></option>
											<option value="MediumSlateBlue"></option>
											<option value="MediumSpringGreen"></option>
											<option value="MediumTurquoise"></option>
											<option value="MediumVioletRed"></option>
											<option value="MidnightBlue"></option>
											<option value="MintCream"></option>
											<option value="MistyRose"></option>
											<option value="Moccasin"></option>
											<option value="NavajoWhite"></option>
											<option value="Navy"></option>
											<option value="OldLace"></option>
											<option value="Olive"></option>
											<option value="OliveDrab"></option>
											<option value="Orange"></option>
											<option value="OrangeRed"></option>
											<option value="Orchid"></option>
											<option value="PaleGoldenRod"></option>
											<option value="PaleGreen"></option>
											<option value="PaleTurquoise"></option>
											<option value="PaleVioletRed"></option>
											<option value="PapayaWhip"></option>
											<option value="Pink"></option>
											<option value="Plum"></option>
											<option value="PowderBlue"></option>
											<option value="Purple"></option>
											<option value="RebeccaPurple"></option>
											<option value="Red"></option>
											<option value="RosyBrown"></option>
											<option value="RoyalBlue"></option>
											<option value="SaddleBrown"></option>
											<option value="Salmon"></option>
											<option value="SandyBrown"></option>
											<option value="SeaGreen"></option>
											<option value="SeaShell"></option>
											<option value="Sienna"></option>
											<option value="Silver"></option>
											<option value="SkyBlue"></option>
											<option value="SlateBlue"></option>
											<option value="SlateGray"></option>
											<option value="SlateGrey"></option>
											<option value="Snow"></option>
											<option value="SpringGreen"></option>
											<option value="SteelBlue"></option>
											<option value="Tan"></option>
											<option value="Teal"></option>
											<option value="Thistle"></option>
											<option value="Tomato"></option>
											<option value="Turquoise"></option>
											<option value="Violet"></option>
											<option value="Wheat"></option>
											<option value="WhiteSmoke"></option>
											<option value="Yellow"></option>
											<option value="YellowGreen"></option>
										</select>
									</span>
									<span class="ql-formats">
										<button type="button" class="ql-strike" aria-label="Rayé"></button>
										<button type="button" class="ql-list" value="ordered" aria-label="Liste"></button>
										<button type="button" class="ql-list" value="bullet" aria-label="Puce"></button>
									</span>
									<span class="ql-formats">
										<button type="button" class="ql-link" aria-label="Lien"></button>
									</span>
								</ng-template>
							</p-editor>
							<p>
								<strong>Important:</strong> Positionnez la valeur LIEN_OK et LIEN_KO
								qui sera remplacé par les liens idoines.
							</p>
						</div>

						<div class="form-group">
							<label class="ls-label-strong" for="mail-moreinfo">Pour info</label>
							<p-editor formControlName="emailMoreInfoControl" [style]="{'height':'150px'}">
								<ng-template pTemplate="header">
									<span class="ql-formats">
										<button type="button" class="ql-bold" aria-label="Gras"></button>
										<button type="button" class="ql-italic" aria-label="Italique"></button>
										<button type="button" class="ql-underline" aria-label="Souligné"></button>
									</span>
									<span class="ql-formats">
										<select class="ql-color">
											<option value="Black"></option>
											<option value="White"></option>
											<option value="AliceBlue"></option>
											<option value="AntiqueWhite"></option>
											<option value="Aqua"></option>
											<option value="Aquamarine"></option>
											<option value="Azure"></option>
											<option value="Beige"></option>
											<option value="Bisque"></option>
											<option value="BlanchedAlmond"></option>
											<option value="Blue"></option>
											<option value="BlueViolet"></option>
											<option value="Brown"></option>
											<option value="BurlyWood"></option>
											<option value="CadetBlue"></option>
											<option value="Chartreuse"></option>
											<option value="Chocolate"></option>
											<option value="Coral"></option>
											<option value="CornflowerBlue"></option>
											<option value="Cornsilk"></option>
											<option value="Crimson"></option>
											<option value="Cyan"></option>
											<option value="DarkBlue"></option>
											<option value="DarkCyan"></option>
											<option value="DarkGoldenRod"></option>
											<option value="DarkGray"></option>
											<option value="DarkGrey"></option>
											<option value="DarkGreen"></option>
											<option value="DarkKhaki"></option>
											<option value="DarkMagenta"></option>
											<option value="DarkOliveGreen"></option>
											<option value="DarkOrange"></option>
											<option value="DarkOrchid"></option>
											<option value="DarkRed"></option>
											<option value="DarkSalmon"></option>
											<option value="DarkSeaGreen"></option>
											<option value="DarkSlateBlue"></option>
											<option value="DarkSlateGray"></option>
											<option value="DarkSlateGrey"></option>
											<option value="DarkTurquoise"></option>
											<option value="DarkViolet"></option>
											<option value="DeepPink"></option>
											<option value="DeepSkyBlue"></option>
											<option value="DimGray"></option>
											<option value="DimGrey"></option>
											<option value="DodgerBlue"></option>
											<option value="FireBrick"></option>
											<option value="FloralWhite"></option>
											<option value="ForestGreen"></option>
											<option value="Fuchsia"></option>
											<option value="Gainsboro"></option>
											<option value="GhostWhite"></option>
											<option value="Gold"></option>
											<option value="GoldenRod"></option>
											<option value="Gray"></option>
											<option value="Grey"></option>
											<option value="Green"></option>
											<option value="GreenYellow"></option>
											<option value="HoneyDew"></option>
											<option value="LightGrey"></option>
											<option value="LightGreen"></option>
											<option value="LightPink"></option>
											<option value="LightSalmon"></option>
											<option value="LightSeaGreen"></option>
											<option value="LightSkyBlue"></option>
											<option value="LightSlateGray"></option>
											<option value="LightSlateGrey"></option>
											<option value="LightSteelBlue"></option>
											<option value="LightYellow"></option>
											<option value="Lime"></option>
											<option value="LimeGreen"></option>
											<option value="Linen"></option>
											<option value="Magenta"></option>
											<option value="Maroon"></option>
											<option value="MediumAquaMarine"></option>
											<option value="MediumBlue"></option>
											<option value="MediumOrchid"></option>
											<option value="MediumPurple"></option>
											<option value="MediumSeaGreen"></option>
											<option value="MediumSlateBlue"></option>
											<option value="MediumSpringGreen"></option>
											<option value="MediumTurquoise"></option>
											<option value="MediumVioletRed"></option>
											<option value="MidnightBlue"></option>
											<option value="MintCream"></option>
											<option value="MistyRose"></option>
											<option value="Moccasin"></option>
											<option value="NavajoWhite"></option>
											<option value="Navy"></option>
											<option value="OldLace"></option>
											<option value="Olive"></option>
											<option value="OliveDrab"></option>
											<option value="Orange"></option>
											<option value="OrangeRed"></option>
											<option value="Orchid"></option>
											<option value="PaleGoldenRod"></option>
											<option value="PaleGreen"></option>
											<option value="PaleTurquoise"></option>
											<option value="PaleVioletRed"></option>
											<option value="PapayaWhip"></option>
											<option value="Pink"></option>
											<option value="Plum"></option>
											<option value="PowderBlue"></option>
											<option value="Purple"></option>
											<option value="RebeccaPurple"></option>
											<option value="Red"></option>
											<option value="RosyBrown"></option>
											<option value="RoyalBlue"></option>
											<option value="SaddleBrown"></option>
											<option value="Salmon"></option>
											<option value="SandyBrown"></option>
											<option value="SeaGreen"></option>
											<option value="SeaShell"></option>
											<option value="Sienna"></option>
											<option value="Silver"></option>
											<option value="SkyBlue"></option>
											<option value="SlateBlue"></option>
											<option value="SlateGray"></option>
											<option value="SlateGrey"></option>
											<option value="Snow"></option>
											<option value="SpringGreen"></option>
											<option value="SteelBlue"></option>
											<option value="Tan"></option>
											<option value="Teal"></option>
											<option value="Thistle"></option>
											<option value="Tomato"></option>
											<option value="Turquoise"></option>
											<option value="Violet"></option>
											<option value="Wheat"></option>
											<option value="WhiteSmoke"></option>
											<option value="Yellow"></option>
											<option value="YellowGreen"></option>
										</select>
										<select class="ql-background">
											<option value="Black"></option>
											<option value="White"></option>
											<option value="AliceBlue"></option>
											<option value="AntiqueWhite"></option>
											<option value="Aqua"></option>
											<option value="Aquamarine"></option>
											<option value="Azure"></option>
											<option value="Beige"></option>
											<option value="Bisque"></option>
											<option value="BlanchedAlmond"></option>
											<option value="Blue"></option>
											<option value="BlueViolet"></option>
											<option value="Brown"></option>
											<option value="BurlyWood"></option>
											<option value="CadetBlue"></option>
											<option value="Chartreuse"></option>
											<option value="Chocolate"></option>
											<option value="Coral"></option>
											<option value="CornflowerBlue"></option>
											<option value="Cornsilk"></option>
											<option value="Crimson"></option>
											<option value="Cyan"></option>
											<option value="DarkBlue"></option>
											<option value="DarkCyan"></option>
											<option value="DarkGoldenRod"></option>
											<option value="DarkGray"></option>
											<option value="DarkGrey"></option>
											<option value="DarkGreen"></option>
											<option value="DarkKhaki"></option>
											<option value="DarkMagenta"></option>
											<option value="DarkOliveGreen"></option>
											<option value="DarkOrange"></option>
											<option value="DarkOrchid"></option>
											<option value="DarkRed"></option>
											<option value="DarkSalmon"></option>
											<option value="DarkSeaGreen"></option>
											<option value="DarkSlateBlue"></option>
											<option value="DarkSlateGray"></option>
											<option value="DarkSlateGrey"></option>
											<option value="DarkTurquoise"></option>
											<option value="DarkViolet"></option>
											<option value="DeepPink"></option>
											<option value="DeepSkyBlue"></option>
											<option value="DimGray"></option>
											<option value="DimGrey"></option>
											<option value="DodgerBlue"></option>
											<option value="FireBrick"></option>
											<option value="FloralWhite"></option>
											<option value="ForestGreen"></option>
											<option value="Fuchsia"></option>
											<option value="Gainsboro"></option>
											<option value="GhostWhite"></option>
											<option value="Gold"></option>
											<option value="GoldenRod"></option>
											<option value="Gray"></option>
											<option value="Grey"></option>
											<option value="Green"></option>
											<option value="GreenYellow"></option>
											<option value="HoneyDew"></option>
											<option value="LightGrey"></option>
											<option value="LightGreen"></option>
											<option value="LightPink"></option>
											<option value="LightSalmon"></option>
											<option value="LightSeaGreen"></option>
											<option value="LightSkyBlue"></option>
											<option value="LightSlateGray"></option>
											<option value="LightSlateGrey"></option>
											<option value="LightSteelBlue"></option>
											<option value="LightYellow"></option>
											<option value="Lime"></option>
											<option value="LimeGreen"></option>
											<option value="Linen"></option>
											<option value="Magenta"></option>
											<option value="Maroon"></option>
											<option value="MediumAquaMarine"></option>
											<option value="MediumBlue"></option>
											<option value="MediumOrchid"></option>
											<option value="MediumPurple"></option>
											<option value="MediumSeaGreen"></option>
											<option value="MediumSlateBlue"></option>
											<option value="MediumSpringGreen"></option>
											<option value="MediumTurquoise"></option>
											<option value="MediumVioletRed"></option>
											<option value="MidnightBlue"></option>
											<option value="MintCream"></option>
											<option value="MistyRose"></option>
											<option value="Moccasin"></option>
											<option value="NavajoWhite"></option>
											<option value="Navy"></option>
											<option value="OldLace"></option>
											<option value="Olive"></option>
											<option value="OliveDrab"></option>
											<option value="Orange"></option>
											<option value="OrangeRed"></option>
											<option value="Orchid"></option>
											<option value="PaleGoldenRod"></option>
											<option value="PaleGreen"></option>
											<option value="PaleTurquoise"></option>
											<option value="PaleVioletRed"></option>
											<option value="PapayaWhip"></option>
											<option value="Pink"></option>
											<option value="Plum"></option>
											<option value="PowderBlue"></option>
											<option value="Purple"></option>
											<option value="RebeccaPurple"></option>
											<option value="Red"></option>
											<option value="RosyBrown"></option>
											<option value="RoyalBlue"></option>
											<option value="SaddleBrown"></option>
											<option value="Salmon"></option>
											<option value="SandyBrown"></option>
											<option value="SeaGreen"></option>
											<option value="SeaShell"></option>
											<option value="Sienna"></option>
											<option value="Silver"></option>
											<option value="SkyBlue"></option>
											<option value="SlateBlue"></option>
											<option value="SlateGray"></option>
											<option value="SlateGrey"></option>
											<option value="Snow"></option>
											<option value="SpringGreen"></option>
											<option value="SteelBlue"></option>
											<option value="Tan"></option>
											<option value="Teal"></option>
											<option value="Thistle"></option>
											<option value="Tomato"></option>
											<option value="Turquoise"></option>
											<option value="Violet"></option>
											<option value="Wheat"></option>
											<option value="WhiteSmoke"></option>
											<option value="Yellow"></option>
											<option value="YellowGreen"></option>
										</select>
									</span>
									<span class="ql-formats">
										<button type="button" class="ql-strike" aria-label="Rayé"></button>
										<button type="button" class="ql-list" value="ordered" aria-label="Liste"></button>
										<button type="button" class="ql-list" value="bullet" aria-label="Puce"></button>
									</span>
									<span class="ql-formats">
										<button type="button" class="ql-link" aria-label="Lien"></button>
									</span>
								</ng-template>
							</p-editor>
						</div>

						<div class="form-group">
							<label class="ls-label-strong" for="mail-signature">Signature</label>
							<p-editor formControlName="emailSignatureControl" [style]="{'height':'150px'}">
								<ng-template pTemplate="header">
									<span class="ql-formats">
										<button type="button" class="ql-bold" aria-label="Gras"></button>
										<button type="button" class="ql-italic" aria-label="Italique"></button>
										<button type="button" class="ql-underline" aria-label="Souligné"></button>
									</span>
									<span class="ql-formats">
										<select class="ql-color">
											<option value="Black"></option>
											<option value="White"></option>
											<option value="AliceBlue"></option>
											<option value="AntiqueWhite"></option>
											<option value="Aqua"></option>
											<option value="Aquamarine"></option>
											<option value="Azure"></option>
											<option value="Beige"></option>
											<option value="Bisque"></option>
											<option value="BlanchedAlmond"></option>
											<option value="Blue"></option>
											<option value="BlueViolet"></option>
											<option value="Brown"></option>
											<option value="BurlyWood"></option>
											<option value="CadetBlue"></option>
											<option value="Chartreuse"></option>
											<option value="Chocolate"></option>
											<option value="Coral"></option>
											<option value="CornflowerBlue"></option>
											<option value="Cornsilk"></option>
											<option value="Crimson"></option>
											<option value="Cyan"></option>
											<option value="DarkBlue"></option>
											<option value="DarkCyan"></option>
											<option value="DarkGoldenRod"></option>
											<option value="DarkGray"></option>
											<option value="DarkGrey"></option>
											<option value="DarkGreen"></option>
											<option value="DarkKhaki"></option>
											<option value="DarkMagenta"></option>
											<option value="DarkOliveGreen"></option>
											<option value="DarkOrange"></option>
											<option value="DarkOrchid"></option>
											<option value="DarkRed"></option>
											<option value="DarkSalmon"></option>
											<option value="DarkSeaGreen"></option>
											<option value="DarkSlateBlue"></option>
											<option value="DarkSlateGray"></option>
											<option value="DarkSlateGrey"></option>
											<option value="DarkTurquoise"></option>
											<option value="DarkViolet"></option>
											<option value="DeepPink"></option>
											<option value="DeepSkyBlue"></option>
											<option value="DimGray"></option>
											<option value="DimGrey"></option>
											<option value="DodgerBlue"></option>
											<option value="FireBrick"></option>
											<option value="FloralWhite"></option>
											<option value="ForestGreen"></option>
											<option value="Fuchsia"></option>
											<option value="Gainsboro"></option>
											<option value="GhostWhite"></option>
											<option value="Gold"></option>
											<option value="GoldenRod"></option>
											<option value="Gray"></option>
											<option value="Grey"></option>
											<option value="Green"></option>
											<option value="GreenYellow"></option>
											<option value="HoneyDew"></option>
											<option value="LightGrey"></option>
											<option value="LightGreen"></option>
											<option value="LightPink"></option>
											<option value="LightSalmon"></option>
											<option value="LightSeaGreen"></option>
											<option value="LightSkyBlue"></option>
											<option value="LightSlateGray"></option>
											<option value="LightSlateGrey"></option>
											<option value="LightSteelBlue"></option>
											<option value="LightYellow"></option>
											<option value="Lime"></option>
											<option value="LimeGreen"></option>
											<option value="Linen"></option>
											<option value="Magenta"></option>
											<option value="Maroon"></option>
											<option value="MediumAquaMarine"></option>
											<option value="MediumBlue"></option>
											<option value="MediumOrchid"></option>
											<option value="MediumPurple"></option>
											<option value="MediumSeaGreen"></option>
											<option value="MediumSlateBlue"></option>
											<option value="MediumSpringGreen"></option>
											<option value="MediumTurquoise"></option>
											<option value="MediumVioletRed"></option>
											<option value="MidnightBlue"></option>
											<option value="MintCream"></option>
											<option value="MistyRose"></option>
											<option value="Moccasin"></option>
											<option value="NavajoWhite"></option>
											<option value="Navy"></option>
											<option value="OldLace"></option>
											<option value="Olive"></option>
											<option value="OliveDrab"></option>
											<option value="Orange"></option>
											<option value="OrangeRed"></option>
											<option value="Orchid"></option>
											<option value="PaleGoldenRod"></option>
											<option value="PaleGreen"></option>
											<option value="PaleTurquoise"></option>
											<option value="PaleVioletRed"></option>
											<option value="PapayaWhip"></option>
											<option value="Pink"></option>
											<option value="Plum"></option>
											<option value="PowderBlue"></option>
											<option value="Purple"></option>
											<option value="RebeccaPurple"></option>
											<option value="Red"></option>
											<option value="RosyBrown"></option>
											<option value="RoyalBlue"></option>
											<option value="SaddleBrown"></option>
											<option value="Salmon"></option>
											<option value="SandyBrown"></option>
											<option value="SeaGreen"></option>
											<option value="SeaShell"></option>
											<option value="Sienna"></option>
											<option value="Silver"></option>
											<option value="SkyBlue"></option>
											<option value="SlateBlue"></option>
											<option value="SlateGray"></option>
											<option value="SlateGrey"></option>
											<option value="Snow"></option>
											<option value="SpringGreen"></option>
											<option value="SteelBlue"></option>
											<option value="Tan"></option>
											<option value="Teal"></option>
											<option value="Thistle"></option>
											<option value="Tomato"></option>
											<option value="Turquoise"></option>
											<option value="Violet"></option>
											<option value="Wheat"></option>
											<option value="WhiteSmoke"></option>
											<option value="Yellow"></option>
											<option value="YellowGreen"></option>
										</select>
										<select class="ql-background">
											<option value="Black"></option>
											<option value="White"></option>
											<option value="AliceBlue"></option>
											<option value="AntiqueWhite"></option>
											<option value="Aqua"></option>
											<option value="Aquamarine"></option>
											<option value="Azure"></option>
											<option value="Beige"></option>
											<option value="Bisque"></option>
											<option value="BlanchedAlmond"></option>
											<option value="Blue"></option>
											<option value="BlueViolet"></option>
											<option value="Brown"></option>
											<option value="BurlyWood"></option>
											<option value="CadetBlue"></option>
											<option value="Chartreuse"></option>
											<option value="Chocolate"></option>
											<option value="Coral"></option>
											<option value="CornflowerBlue"></option>
											<option value="Cornsilk"></option>
											<option value="Crimson"></option>
											<option value="Cyan"></option>
											<option value="DarkBlue"></option>
											<option value="DarkCyan"></option>
											<option value="DarkGoldenRod"></option>
											<option value="DarkGray"></option>
											<option value="DarkGrey"></option>
											<option value="DarkGreen"></option>
											<option value="DarkKhaki"></option>
											<option value="DarkMagenta"></option>
											<option value="DarkOliveGreen"></option>
											<option value="DarkOrange"></option>
											<option value="DarkOrchid"></option>
											<option value="DarkRed"></option>
											<option value="DarkSalmon"></option>
											<option value="DarkSeaGreen"></option>
											<option value="DarkSlateBlue"></option>
											<option value="DarkSlateGray"></option>
											<option value="DarkSlateGrey"></option>
											<option value="DarkTurquoise"></option>
											<option value="DarkViolet"></option>
											<option value="DeepPink"></option>
											<option value="DeepSkyBlue"></option>
											<option value="DimGray"></option>
											<option value="DimGrey"></option>
											<option value="DodgerBlue"></option>
											<option value="FireBrick"></option>
											<option value="FloralWhite"></option>
											<option value="ForestGreen"></option>
											<option value="Fuchsia"></option>
											<option value="Gainsboro"></option>
											<option value="GhostWhite"></option>
											<option value="Gold"></option>
											<option value="GoldenRod"></option>
											<option value="Gray"></option>
											<option value="Grey"></option>
											<option value="Green"></option>
											<option value="GreenYellow"></option>
											<option value="HoneyDew"></option>
											<option value="LightGrey"></option>
											<option value="LightGreen"></option>
											<option value="LightPink"></option>
											<option value="LightSalmon"></option>
											<option value="LightSeaGreen"></option>
											<option value="LightSkyBlue"></option>
											<option value="LightSlateGray"></option>
											<option value="LightSlateGrey"></option>
											<option value="LightSteelBlue"></option>
											<option value="LightYellow"></option>
											<option value="Lime"></option>
											<option value="LimeGreen"></option>
											<option value="Linen"></option>
											<option value="Magenta"></option>
											<option value="Maroon"></option>
											<option value="MediumAquaMarine"></option>
											<option value="MediumBlue"></option>
											<option value="MediumOrchid"></option>
											<option value="MediumPurple"></option>
											<option value="MediumSeaGreen"></option>
											<option value="MediumSlateBlue"></option>
											<option value="MediumSpringGreen"></option>
											<option value="MediumTurquoise"></option>
											<option value="MediumVioletRed"></option>
											<option value="MidnightBlue"></option>
											<option value="MintCream"></option>
											<option value="MistyRose"></option>
											<option value="Moccasin"></option>
											<option value="NavajoWhite"></option>
											<option value="Navy"></option>
											<option value="OldLace"></option>
											<option value="Olive"></option>
											<option value="OliveDrab"></option>
											<option value="Orange"></option>
											<option value="OrangeRed"></option>
											<option value="Orchid"></option>
											<option value="PaleGoldenRod"></option>
											<option value="PaleGreen"></option>
											<option value="PaleTurquoise"></option>
											<option value="PaleVioletRed"></option>
											<option value="PapayaWhip"></option>
											<option value="Pink"></option>
											<option value="Plum"></option>
											<option value="PowderBlue"></option>
											<option value="Purple"></option>
											<option value="RebeccaPurple"></option>
											<option value="Red"></option>
											<option value="RosyBrown"></option>
											<option value="RoyalBlue"></option>
											<option value="SaddleBrown"></option>
											<option value="Salmon"></option>
											<option value="SandyBrown"></option>
											<option value="SeaGreen"></option>
											<option value="SeaShell"></option>
											<option value="Sienna"></option>
											<option value="Silver"></option>
											<option value="SkyBlue"></option>
											<option value="SlateBlue"></option>
											<option value="SlateGray"></option>
											<option value="SlateGrey"></option>
											<option value="Snow"></option>
											<option value="SpringGreen"></option>
											<option value="SteelBlue"></option>
											<option value="Tan"></option>
											<option value="Teal"></option>
											<option value="Thistle"></option>
											<option value="Tomato"></option>
											<option value="Turquoise"></option>
											<option value="Violet"></option>
											<option value="Wheat"></option>
											<option value="WhiteSmoke"></option>
											<option value="Yellow"></option>
											<option value="YellowGreen"></option>
										</select>
									</span>
									<span class="ql-formats">
										<button type="button" class="ql-strike" aria-label="Rayé"></button>
										<button type="button" class="ql-list" value="ordered" aria-label="Liste"></button>
										<button type="button" class="ql-list" value="bullet" aria-label="Puce"></button>
									</span>
									<span class="ql-formats">
										<button type="button" class="ql-link" aria-label="Lien"></button>
									</span>
								</ng-template>
							</p-editor>
						</div>

						<div class="form-group">
							<input type="checkbox" formControlName="emailSendToUserControl" id="mail-send-to-user" />
							&nbsp;
							<label class="ls-label-strong" for="mail-send-to-user">Recevoir une copie du mail</label>
						</div>

						<div class="form-group">
							<button type="button" class="btn btn-success" (click)="testMail()">Envoi de test</button>
						</div>
					</ng-template>
				</li>
			</ul>

			<div [ngbNavOutlet]="nav" class="mt-2"></div>
			<br>
		</form>
	</div>

	<div class="modal-footer">
		<button type="button" class="btn btn-light" (click)="cancelDialog()">Annuler</button>
		<button type="submit" class="btn btn-primary" [disabled]="!enableAction || !folderAddForm.valid" (click)="save()">{{buttonText}}</button>
	</div>
</div>
